import { render, staticRenderFns } from "./GESPCodeList.vue?vue&type=template&id=208d6054&scoped=true"
import script from "./GESPCodeList.vue?vue&type=script&lang=js"
export * from "./GESPCodeList.vue?vue&type=script&lang=js"
import style0 from "./GESPCodeList.vue?vue&type=style&index=0&id=208d6054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d6054",
  null
  
)

export default component.exports